/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestFilterCountsCompanyValues
 */
export interface RequestFilterCountsCompanyValues {
    /**
     * 
     * @type {number}
     * @memberof RequestFilterCountsCompanyValues
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestFilterCountsCompanyValues
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RequestFilterCountsCompanyValues
     */
    values: Array<string>;
}

export function RequestFilterCountsCompanyValuesFromJSON(json: any): RequestFilterCountsCompanyValues {
    return RequestFilterCountsCompanyValuesFromJSONTyped(json, false);
}

export function RequestFilterCountsCompanyValuesFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestFilterCountsCompanyValues {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'name': json['name'],
        'values': json['values'],
    };
}

export function RequestFilterCountsCompanyValuesToJSON(value?: RequestFilterCountsCompanyValues | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'name': value.name,
        'values': value.values,
    };
}


